<template>
  <virtual-tree :data="originTree" :checked="checked" @change="checkedChange" :clearable="clearable"
    :props="props" :placeholder="placeholder" :multiple="multiple" v-bind="$attrs" @select-focus="dealSelectFocus"></virtual-tree>
</template>

<script>
import virtualTree from './virtualTree'
export default {
  name: 'yblInsuranceType',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    items: {
      type: Array | Object,
      default: () => []
    },
    checked: {
      type: Array | String,
      default: () => []
    },
    isFeiche: { // 是否非车  非车保单查询，默认不查询数据 有保司数据得时候才会查询数据
      type: Boolean,
      default: () => false
    },
    dataType: {
      type: Number,
      default: () => 1
    },
    insSupplierList: {
      type: Number | Array,
      default: () => 0
    },
    configInsurancetValue: { // 非车险种联动值
      type: Array | Number,
      default: () => []
    },
    configProductValue: { // 非车产品联动值
      type: Object,
      default: () => null
    },
    issystemtype: { //  0是系统 1是自定义 2是不传，查全部
      type: Number,
      default: () => 2
    },
    props: {
      type: Object,
      default () {
        return { label: 'insdetailname', id: 'id', parentId: 'leveltype', isTree: false }
      }
    },
    planIdsFilter: { // 非车指定产品过滤
      type: [Array, Boolean],
      default: () => false
    },
    sourceList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selected: '',
      placeholder: '请选择',
      dataTypeList: [],
      originProducts: [],
      originTree: []
    }
  },
  created () {
    if (this.dataType) {
      this.dataTypeList = this.typeScreening(this.dataType).value
      this.placeholder = this.typeScreening(this.dataType).placeholder
    }
    // this.getInsuranceCode().then(data => {
    //   this.originTree = data
    //   this.originProducts = [...data]
    //   this.getTreeData()
    // })
    this.upData()
  },
  computed: {
    clearable () {
      return this.$attrs.clearable === undefined ? true : this.$attrs.clearable
    },
    multiple () {
      return this.$attrs.showCheckbox || false
    }
  },
  components: {
    virtualTree
  },
  methods: {
    dealSelectFocus () {
      // 非车保单查询 保司无数据，提示请选择保司
      const insSupplierList = Array.isArray(this.insSupplierList) ? this.insSupplierList : (this.insSupplierList ? [this.insSupplierList] : [])
      if (insSupplierList.length === 0 && this.isFeiche) {
        this.$message.info('请选择保司')
      }
    },
    upData () { // 更新数据
      const insSupplierList = Array.isArray(this.insSupplierList) ? this.insSupplierList : (this.insSupplierList ? [this.insSupplierList] : [])
      if (insSupplierList.length === 0 && this.isFeiche) {
        // this.$message.info('请先选择保司')
        this.originTree = []
        this.originProducts = []
        this.getTreeData()
        return
      }
      this.getInsuranceCode().then(data => {
        this.originTree = data
        this.originProducts = [...data]
        this.getTreeData()
      })
    },
    getTreeData () {
      const insuranceValue = this.configInsurancetValue
      const values = Array.isArray(insuranceValue) ? insuranceValue : (((insuranceValue || insuranceValue === 0) && [insuranceValue]) || [])
      if (values && values.length > 0) {
        const _values = values.map(item => +item)
        // 这部分的数据过滤，具有定制型（仅支持非车产品/险种）
        this.originTree = this.originProducts.filter(item => _values.includes(+item.insuranceId) || _values.includes(+item.productId))
      } else {
        const productValue = this.configProductValue
        const keys = (productValue && Object.keys(productValue)) || []
        if (keys && keys.length > 0) {
          const { id } = this.props
          const productItem = this.originProducts.find(item => +item[id] === +productValue.insuranceId)
          this.$emit('change', (productItem && productItem[id]) || '')
        }
      }
      if (this.planIdsFilter) {
        this.originTree = this.originProducts.filter(it => this.planIdsFilter.includes(it.productId))
      }
    },
    typeScreening (index) {
      let list = [{
        value: [],
        placeholder: ''
      }, {
        value: [0],
        placeholder: '请选择险种'
      }, {
        value: [1],
        placeholder: '请选择产品'
      }, {
        value: [2],
        placeholder: '请选择方案'
      }, {
        value: [1, 2],
        placeholder: '请选择产品或者方案'
      }]
      return list[index]
    },
    checkedChange (value, item) {
      this.$emit('change', value, item)
    },
    getInsuranceCode () {
      let params = {
        dto: {
          dataTypeList: this.dataTypeList,
          insSupplierList: Array.isArray(this.insSupplierList) ? this.insSupplierList : (this.insSupplierList ? [this.insSupplierList] : []),
          resetLevel: this.dataTypeList[0] !== 0,
          status: [0, 3, 8]
        }
      }
      if (this.sourceList.length) params.dto.sourceList = this.sourceList
      if (this.issystemtype !== 2) { // 如果是2就不传issystemtypeList
        params.dto.issystemtypeList = [this.issystemtype]
      }
      return this.$store.dispatch('insurancefcQueryProductList', params).then(data => {
        return data.DtoList || []
      })
    }
  },
  watch: {
    'configInsurancetValue': function (newVal, oldVal) {
      this.originTree = this.originProducts
      newVal && this.getTreeData()
    },
    'configProductValue': function (newVal, oldVal) {
      newVal && this.getTreeData()
    },
    'insSupplierList': function (newVal, oldVal) {
      if (newVal) {
        // this.getInsuranceCode()
        this.upData()
      }
    },
    'planIdsFilter': function (newVal, oldVal) {
      this.getTreeData()
    },
    'sourceList': function (newVal, oldVal) {
      this.upData()
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/insuranceTypeTree.vue